<template>
  <div class="playlet">
    <el-card class="box-card">
      <!-- 选择区 -->
      <div class="selectionArea">
        <div class="item">
          <!-- <span class="title">视频名称</span> -->
          <el-input
            v-model.trim="parameter.title"
            style="width: 300px;"
            clearable
            placeholder="请输入视频名称"
          />
        </div>
        <div class="item">
          <!-- <span class="title">搜索分类id</span> -->
          <!-- <el-input
            v-model="parameter.category_id"
            style="width: 300px;"
            clearable
            placeholder="请输入搜索分类id"
          /> -->
          <el-select
            v-model="parameter.category_id"
            placeholder="请选择分类"
          >
            <el-option
              v-for="item in options"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </div>
        <div class="item">
          <el-select
            v-model="parameter.change_category"
            placeholder="分类情况"
          >
            <el-option
              v-for="item in optionsfenlei"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
        <div class="item">
          <el-button
            size="mini"
            type="primary"
            icon="el-icon-search"
            @click="search"
          >搜索</el-button>
          <el-button
            size="mini"
            type="info"
            icon="el-icon-refresh"
            @click="reset"
          >重置</el-button>
          <el-button
            size="mini"
            type="success"
            icon="el-icon-s-help"
            @click="add"
          >创建</el-button>
          <el-button
            type="danger"
            @click="batchDelete"
            size="mini"
            icon="el-icon-circle-plus"
            :disabled="selectlist.length==0"
          >绑定</el-button>
          <div class="all_vawrw">
            <div style="font-size: 14px;color: #606266;padding-top: 3px;">开启全部小游戏弹窗：</div>
            <div style="position: relative; display: inline-block;">
              <el-switch
                v-model="allpop"
                active-color="#13ce66"
                inactive-color="rgb(191,191,191)"
                :active-value="1"
                :inactive-value="2"
                active-text="开"
                inactive-text="关"
                @change="allpopwer($event)"
              />
              <!-- <div
                v-if="allpop == 1"
                style="color: #fff;position: absolute;top: 2px;left: 7px;"
              >开启</div>
              <div
                v-else
                style="color: #fff;position: absolute;top: 2px;right: 7px;"
              >关闭</div> -->
            </div>
          </div>
        </div>
      </div>
    </el-card>

    <el-card>
      <!-- 主体区 -->
      <div>
        <el-table
          v-loading="loading"
          :data="tableData.list"
          @selection-change="handleSelectionChange"
          :row-key="rowKey"
          border
          style="width: 100%"
          ref="multipleTable"
        >
          <el-table-column
            type="selection"
            align="center"
            width="55"
            :reserve-selection="true"
          />
          <el-table-column
            prop="id"
            label="id"
            width="55"
            align="center"
          />
          <el-table-column
            prop="title"
            label="视频名称"
            width="400"
            align="center"
          >
            <template slot-scope="scope">
              <el-tooltip placement="top">
                <div slot="content">{{ scope.row.title }}</div>
                <div class="ellipsis">{{ scope.row.title }}</div>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            prop="video_cover"
            label="封面路径"
            width="300"
            align="center"
          >
            <template slot-scope="scope">
              <el-tooltip placement="top">
                <div slot="content">{{ scope.row.video_cover }}</div>
                <div class="ellipsis">{{ scope.row.video_cover }}</div>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            prop="video_path"
            label="视频路径"
            width="300"
            align="center"
          >
            <template slot-scope="scope">
              <el-tooltip placement="top">
                <div slot="content">{{ scope.row.video_url }}</div>
                <div class="ellipsis">{{ scope.row.video_url }}</div>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            prop="video_path"
            label="激励广告开启/关闭"
            width="150"
            align="center"
          >
            <template slot-scope="scope">
              <div style="position: relative; display: inline-block;">
                <el-switch
                  v-model="scope.row.open_encourage"
                  :width="60"
                  active-color="#13ce66"
                  inactive-color="rgb(191,191,191)"
                  :active-value="2"
                  :inactive-value="1"
                  @change="encourageall($event, scope.row)"
                />
                <div
                  v-if="scope.row.open_encourage == 2"
                  style="color: #fff;position: absolute;top: 2px;left: 7px;"
                >开启</div>
                <div
                  v-else
                  style="color: #fff;position: absolute;top: 2px;right: 7px;"
                >关闭</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="video_path"
            label="视频广告开启/关闭"
            width="150"
            align="center"
          >
            <template slot-scope="scope">
              <div style="position: relative; display: inline-block;">
                <el-switch
                  v-model="scope.row.open_video_ad"
                  :width="60"
                  active-color="#13ce66"
                  inactive-color="rgb(191,191,191)"
                  :active-value="2"
                  :inactive-value="1"
                  @change="videoall($event, scope.row)"
                />
                <div
                  v-if="scope.row.open_video_ad == 2"
                  style="color: #fff;position: absolute;top: 2px;left: 7px;"
                >开启</div>
                <div
                  v-else
                  style="color: #fff;position: absolute;top: 2px;right: 7px;"
                >关闭</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="pop_game"
            label="弹小游戏开启/关闭"
            width="150"
            align="center"
          >
            <template slot-scope="scope">
              <div style="position: relative; display: inline-block;">
                <el-switch
                  v-model="scope.row.pop_game"
                  :width="60"
                  active-color="#13ce66"
                  inactive-color="rgb(191,191,191)"
                  :active-value="1"
                  :inactive-value="2"
                  @change="videowechatgame($event, scope.row)"
                />
                <div
                  v-if="scope.row.pop_game == 1"
                  style="color: #fff;position: absolute;top: 2px;left: 7px;"
                >开启</div>
                <div
                  v-else
                  style="color: #fff;position: absolute;top: 2px;right: 7px;"
                >关闭</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="create_at_text"
            label="创建时间"
            align="center"
            width="170"
          />
          <el-table-column
            prop="create_at_text"
            label="操作"
            align="center"
          >
            <template slot-scope="scope">
              <el-button
                type="primary"
                size="small"
                @click="editrow(scope.row)"
              >编辑</el-button>
              <!-- @click="editing(scope.row)" -->
              <!-- <el-button
                type="success"
                size="small"
                @click="chooserw(scope.row)"
              >绑定</el-button> -->
              <el-button
                type="danger"
                size="small"
                @click="myDelete(scope.row)"
              >删除</el-button>
              <el-button
                v-clipboard:copy="scope.row.page_path"
                v-clipboard:success="onCopys"
                v-clipboard:error="onError"
                type="primary"
                size="mini"
              >复制链接</el-button>
              <el-button
                type="success"
                size="small"
                @click="vidoedetail(scope.row.id)"
              >视频数据</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <pagination-right
        :total="tableData.total"
        @size-change="fetchPageSize"
        @current-change="fetchCurrentPage"
      />
    </el-card>
    <!-- 选择 -->
    <el-dialog
      title="选择"
      :visible.sync="dialogVisiblemessage"
      :modal-append-to-body="false"
      :append-to-body="true"
      :destroy-on-close="true"
      width="80%"
    >
      <blessdialog
        ref="blessdialogview"
        @updata="updata"
      />
    </el-dialog>
    <el-dialog
      title="编辑"
      :visible.sync="dialogVisibletitle"
      :modal-append-to-body="false"
      :append-to-body="true"
      :destroy-on-close="true"
      width="20%"
    >
      <editdialog
        ref="editdialogview"
        @updataedit="updataedit"
      />
    </el-dialog>
    <el-dialog
      :title="check ? '编辑短视频配置' : '创建短视频配置'"
      :visible.sync="dialogVisible"
      width="800px"
      :before-close="handleClose"
      :destroy-on-close="true"
      :close-on-click-modal="false"
      :append-to-body="true"
    >
      <!-- @close="getDatas" -->
      <detailList
        ref="add"
        @determine="determine"
      />
    </el-dialog>
    <el-dialog
      title="查看数据"
      :visible.sync="dialogVisiblevideodetail"
      :modal-append-to-body="false"
      :append-to-body="true"
      :destroy-on-close="true"
      width="70%"
    >
      <videodetail ref="videodetailview" />
    </el-dialog>
  </div>
</template>

<script>
import PaginationRight from '@/components/PaginationRight/index.vue'
import { videoSettingvideoList, videoSettingopenAd, videoSettingdelVideo, appletLifeVideovideoSettingpopGame, appletLifeVideovideoSettingallCategory, bangfnellie, videoCategorylist } from '@/api/sourceminiprogram.js'
import blessdialog from './components/blessdialog.vue'
import editdialog from './components/editdialog.vue'
import detailList from './components/detailList.vue'
import videodetail from './components/videodetail.vue'
export default {
  components: {
    PaginationRight,
    blessdialog,
    editdialog,
    detailList,
    videodetail
  },
  data() {
    return {
      parameter: {
        page: 1,
        page_size: 10,
        title: '',
        category_id: '',
        change_category: ''
      },
      loading: false,
      tableData: {
        list: [],
        total: null
      },
      options: [],
      allpop: 2,
      dialogVisiblemessage: false,
      dialogVisibletitle: false,
      dialogVisible: false,
      check: undefined,
      selectlist: [],
      selectlistsend: [],
      dialogVisiblevideodetail: false,
      optionsfenlei: [
        {
          value: 1,
          label: '已分类'
        },
        {
          value: 2,
          label: '未分类'
        }
      ]
    }
  },
  computed: {},
  created() {
    this.getDatas()
    this.alllist()
  },
  activated() {
    this.getDatas()
    this.alllist()
  },
  mounted() {},
  methods: {
    rowKey(row) {
      return row.id
    },
    handleSelectionChange(rows) {
      this.selectlist = rows //
    },
    async getDatas() {
      this.loading = true
      const data = await videoSettingvideoList(this.parameter)
      this.tableData = data.data
      this.loading = false
    },
    fetchPageSize(e) {
      this.parameter.page_size = e
      this.getDatas()
    },

    fetchCurrentPage(e) {
      this.parameter.page = e
      this.getDatas()
    },
    async alllist() {
      const data = await videoCategorylist({ page: 1, page_size: 100 })
      this.options = data.data.list
      console.log('alllist', data)
    },
    // 搜索
    search() {
      this.parameter.page = 1
      this.getDatas()
    },

    // 重置
    reset() {
      this.parameter = {
        title: '',
        category_id: '',
        page: 1,
        page_size: 10,
        change_category: ''
      }
      this.getDatas()
    },
    encourageall(e, item) {
      console.log(e, item)
      videoSettingopenAd({
        id: item.id,
        open: e,
        type: 'open_encourage'
      }).then(res => {
        this.$message({
          message: '修改成功',
          type: 'success'
        })
        this.getDatas()
      })
    },
    videoall(e, item) {
      console.log(e, item)
      videoSettingopenAd({
        id: item.id,
        open: e,
        type: 'open_video_ad'
      }).then(res => {
        this.$message({
          message: '修改成功',
          type: 'success'
        })
        this.getDatas()
      })
    },
    videowechatgame(e, item) {
      console.log(e, item)
      appletLifeVideovideoSettingpopGame({
        id: item.id,
        pop_game: e
      }).then(res => {
        this.$message({
          message: '修改成功',
          type: 'success'
        })
        this.getDatas()
      })
    },
    allpopwer(e) {
      appletLifeVideovideoSettingpopGame({
        pop_game: e
      }).then(res => {
        this.$message({
          message: '修改成功',
          type: 'success'
        })
        this.getDatas()
      })
    },
    // 删除
    async myDelete(row) {
      this.$confirm('您确定删除吗')
        .then(async () => {
          await videoSettingdelVideo({ id: row.id })
          this.$message({
            message: '删除成功',
            type: 'success'
          })
          this.getDatas()
        })
        .catch(() => {})
    },
    onError() {
      this.$message.error('复制失败')
    },
    onCopys() {
      this.$message({
        message: '复制成功',
        type: 'success'
      })
    },
    chooserw(item) {
      console.log('item', item)
      this.dialogVisiblemessage = true
      setTimeout(() => {
        // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
        this.$refs.blessdialogview.send(item)
      }, 100)
    },
    editing(item) {
      this.dialogVisibletitle = true
      setTimeout(() => {
        // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
        this.$refs.editdialogview.send(item)
      }, 100)
    },
    updataedit() {
      this.dialogVisibletitle = false
      this.getDatas()
    },
    add() {
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.add.reset()
        this.$refs.add.sendr()
      })
    },
    editrow(row) {
      this.check = row
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.add.sendr(row)
      })
    },
    handleClose() {
      this.check = undefined
      this.dialogVisible = false
    },
    // 提交
    async determine(obj, arr, source_path, cover_path) {
      // console.log('obj:===', obj.cover_path, source_path)
      // if (!obj.id) {
      //   obj.source_path = source_path
      // }
      // try {
      //   obj.id ? await videoSettingUpdate(obj) : await videoSettingAdd(obj)
      //   this.$message({
      //     message: obj.id ? '修改成功' : '创建成功',
      //     type: 'success'
      //   })
      //   this.dialogVisible = false
      //   this.$refs.add.reset()
      //   this.getDatas()
      // } catch (error) {
      //   this.$refs.add.sendr(obj, 999, arr, source_path)
      // }
      this.dialogVisible = false
      this.getDatas()
    },
    batchDelete() {
      this.dialogVisiblemessage = true
      setTimeout(() => {
        // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
        this.$refs.blessdialogview.send()
      }, 100)
    },
    updata(category_id) {
      console.log('category_id', category_id, this.selectlist)
      this.dialogVisiblemessage = false
      this.selectlistsend = []
      this.selectlistsend = this.selectlist.map((item, index) => {
        // eslint-disable-next-line eqeqeq
        return item.id
      })
      this.$confirm('确定要绑定吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'warning'
      })
        .then(() => {
          bangfnellie({
            ids: this.selectlistsend,
            category_id: category_id
          }).then(res => {
            this.$message({
              type: 'success',
              message: `绑定成功`
            })
            this.selectlist = []
            this.$refs.multipleTable.clearSelection()
            this.getDatas()
            // setTimeout(() => {
            //   this.list()
            // }, 2000)
          })
        })
        .catch(() => {})
    },
    vidoedetail(id) {
      // console.log('id', id)
      // this.dialogVisiblevideodetail = true
      // this.$nextTick(() => {
      //   this.$refs.videodetailview.send(id)
      // })
      this.$router.push({ path: '/video/historydata', query: { id: id } })
    }
  }
}
</script>

<style scoped>
.selectionArea {
  display: flex;
  flex-wrap: wrap;
}

.item {
  display: flex;
  align-items: center;
  /* flex-basis: calc(33.33% - 10px); */
  margin-right: 10px;
  margin-bottom: 10px;
}

.title {
  white-space: pre;
  display: inline-block;
  margin-right: 7px;
}

.button-group {
  flex-basis: 100%; /* 按钮组占据一整行宽度 */
}
.ellipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.hidden-row {
  display: none;
}
.toggle-button {
  cursor: pointer;
  text-align: center;
}
.all_vawrw {
  display: flex;
  /* align-items: center; */
  margin-left: 20px;
}
</style>

